/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Guard_OverlineInputs */

const en_mk_sec_pg_guard_overline = /** @type {(inputs: Mk_Sec_Pg_Guard_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent guardrails`)
};

const id_mk_sec_pg_guard_overline = /** @type {(inputs: Mk_Sec_Pg_Guard_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar agen`)
};

/**
* | output |
* | --- |
* | "Agent guardrails" |
*
* @param {Mk_Sec_Pg_Guard_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_guard_overline = /** @type {((inputs?: Mk_Sec_Pg_Guard_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Guard_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_guard_overline(inputs)
	return en_mk_sec_pg_guard_overline(inputs)
});